import { render, staticRenderFns } from "./recover_modal.vue?vue&type=template&id=906632ea"
import script from "./recover_modal.vue?vue&type=script&lang=js"
export * from "./recover_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports